import { render, staticRenderFns } from "./addfriend.vue?vue&type=template&id=5cd0b4f1&scoped=true"
import script from "./addfriend.vue?vue&type=script&lang=js"
export * from "./addfriend.vue?vue&type=script&lang=js"
import style0 from "./addfriend.vue?vue&type=style&index=0&id=5cd0b4f1&prod&lang=scss&scoped=true"
import style1 from "./addfriend.vue?vue&type=style&index=1&id=5cd0b4f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd0b4f1",
  null
  
)

export default component.exports